export default [
  {
    name: 'ProductTemplatesEdit',
    path: '/settings/products/:id/product-templates',
    component: () => import('pages/settings/product-templates/ProductTemplatesForm.vue')
  }
]
